/**
 * This is a reducer for everything related to notifications
 */
import { VisitActionsTypes } from './visit-actions';
import { VisitCountByStateResult, Visit, Opportunity } from '../../api/model';
import initialState from '../../initialState';
import { LoadedSingleResource, LoadedResource } from '../StoreModel';
import StoreModel from '../StoreModel';


export interface IVisitStore {
    resume: LoadedResource<VisitCountByStateResult>;

    byId: {
        [k: string]: LoadedSingleResource<Opportunity>
    };

    visitById: {
        [k: string]: LoadedSingleResource<Visit>
    };

    byState: {
        [k: string]: LoadedResource<Opportunity>
    };

    current: LoadedSingleResource<Opportunity>;

    all: LoadedResource<any>;
}

export default (state = initialState.visit, action?: any): IVisitStore => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case VisitActionsTypes.RESUME_FETCH:
            return { ...state, resume: StoreModel.fetching() };

        case VisitActionsTypes.RESUME_ERROR:
            return { ...state, resume: StoreModel.error(action.payload) };

        case VisitActionsTypes.RESUME_RESULT:
            return { ...state, resume: StoreModel.result(action.payload) };

        case VisitActionsTypes.ALL_FETCH:
            return { ...state, all: StoreModel.fetching() };

        case VisitActionsTypes.ALL_ERROR:
            return { ...state, all: StoreModel.error(action.payload) };

        case VisitActionsTypes.ALL_RESULT:
            return { ...state, all: StoreModel.result(action.payload) };

        case VisitActionsTypes.BY_STATE_FETCH:
            return {
                ...state,
                byState: {
                    ...state.byState,
                    [action.state]: { fetching: true, }
                }
            };

        case VisitActionsTypes.SINGLE_FETCH:
            return {
                ...state,
                byId: { [action.payload.id]: StoreModel.fetchingSingle() }
            }

        case VisitActionsTypes.SINGLE_RESULT:
            return {
                ...state,
                byId: { [action.payload.id]: StoreModel.resultSingle(action.payload.data) }
            }

        case VisitActionsTypes.SINGLE_ERROR:
            return {
                ...state,
                byId: { [action.payload.id]: StoreModel.errorSingle(action.payload.err) }
            }

        case VisitActionsTypes.SINGLE_FETCH_VIS:
            return {
                ...state,
                visitById: { [action.payload.id]: StoreModel.fetchingSingle() }
            }

        case VisitActionsTypes.SINGLE_RESULT_VIS:
            console.log('resultado action: ', action.payload)
            return {
                ...state,
                visitById: { [action.payload.id]: StoreModel.resultSingle(action.payload.visit) }
            }

        case VisitActionsTypes.SINGLE_ERROR_VIS:
            return {
                ...state,
                visitById: { [action.payload.id]: StoreModel.errorSingle(action.payload.err) }
            }

        case VisitActionsTypes.BY_STATE_RESULT:
            return {
                ...state,
                byState: {
                    ...state.byState,
                    [action.state]: { fetching: false, data: action.payload }
                }
            };

        case VisitActionsTypes.BY_STATE_ERROR:
            return {
                ...state,
                byState: {
                    ...state.byState,
                    [action.state]: { fetching: false, err: action.payload }
                }
            };

        case VisitActionsTypes.REQUEST_ADD:
            return { ...state, current: StoreModel.fetchingSingle() };

        case VisitActionsTypes.RESULT_ADD:
            return { ...state, current: StoreModel.resultSingle(action.payload) };

        case VisitActionsTypes.ERROR_ADD:
            return { ...state, current: StoreModel.errorSingle(action.payload) };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/visit/visit-reducer.ts